import { Add, CalendarMonth, Layers, Timeline } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useStore } from "@priolo/jon";
import ButtonCmp from "components/controls/buttons/ButtonCmp";
import dayjs from "dayjs";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import attachSo from "stores/attachment";
import dialogSo, { CYCLE_EDIT_TYPE } from "stores/cycle/editDialog";
import { CYCLE_STATUS } from "stores/cycle/types";
import { getCycleStatus } from "stores/cycle/utils/cycle";
import draftSo from "stores/draft";
import { SESSION_TYPE } from "stores/draft/type";
import growUnitSo from "stores/growUnit";
import incidentSo from "stores/incidents";
import { getNewIncident } from "stores/incidents/utils";
import { getRef } from "utils/humanize";
import HarvestButton from "./HarvestButton";
import SplitButton from "./SplitButton";
import userSo from "stores/user";



/**
 * la zona di ACTIONS (cioe' la bottoniera che sta sotto alla dialog cycle)
 */
const Actions: FunctionComponent = () => {

    // STORE
    const dialogSa = useStore(dialogSo)
    useStore(draftSo)
    useStore(attachSo)

    // HOOKS
    const { t } = useTranslation()

    // HANDLEs
    const handleClose = () => dialogSo.close(CYCLE_EDIT_TYPE.CLOSE)
    const handleSync = () => dialogSo.taskSync()
    const handleNewIncident = () => incidentSo.edit(getNewIncident(dialogSa.cycle.id))
    const handleTimeSeries = () => {
        const cycle = dialogSa.cycle
        if (!cycle || !cycle.seedingDate) return
        const orgId = "1"
        const growUnit = growUnitSo.getByID(cycle.growUnitId)
        const cycleRef = getRef(cycle.cycleUuid)
        const from = dayjs(cycle.seedingDate).valueOf()
        const to = dayjs(cycle.harvestingDate ?? Date.now()).valueOf()
        window.open(`https://dashboards.zerofarms.it/d/txG7exXIk/cycle-dashboard?orgId=${orgId}&var-grow_unit_code=${growUnit.growUnitCode}&var-cycle_id=${cycleRef}&from=${from}&to=${to}`, "timeSeries")
    }
    const handleSortPhotos = () => {
        attachSo.setSortType(attachSo.state.sortType == "date" ? "layer" : "date")
    }

    // RENDER
    const cycleStatus = getCycleStatus(dialogSa.cycle)
    const canHarvest = cycleStatus == CYCLE_STATUS.RUNNING || cycleStatus == CYCLE_STATUS.HARVESTED
    // è possibile SYNC solo su PROD
    const session = draftSo.getSessionSelect()
    const disableSync = !!session && (session.type != SESSION_TYPE.PROD || dialogSa.syncDisabled)
    const tooltipMsg = disableSync ? t("pag.cycle.edit.no-only-read") : null

    const bttSortLabel = attachSo.state.sortType == "date" ? "SORT BY DATE" : "SORT BY LAYER"
    const iconSort = attachSo.state.sortType == "date" ? <CalendarMonth /> : <Layers />

    return <>

        {/* LEFT SIDE */}

        {[
            // DETAIL
            <Button
                startIcon={<Timeline />}
                onClick={handleTimeSeries}
            >TIME SERIES</Button>,
            // CROP LOT
            null,
            // TASKS
            null,
            // CONSUMPTION
            null,
            // INCIDENTS
            null,
            // PHOTOS
            <Button
                startIcon={iconSort}
                onClick={handleSortPhotos}
            >{bttSortLabel}</Button>,

        ][dialogSa.tab] ?? null}

        <Box sx={{ flex: 1 }} />


        {/* RIGHT SIDE */}

        <Button
            onClick={handleClose}
        >{t("pag.cycle.edit.btt-close")}</Button>

        {[
            // DETAIL
            <>
                <SplitButton />
                <HarvestButton
                    disabled={!canHarvest}
                    tooltip={!canHarvest ? "CYCLE NOT IN RUNNING STATUS" : null}
                />
            </>,

            // CROP LOT
            null,

            // TASKS
            <ButtonCmp color="secondary"
                tooltip={tooltipMsg}
                onClick={handleSync}
                disabled={disableSync}
            >{t("pag.cycle.edit.btt-sync")}</ButtonCmp>,

            // CONSUMPTION
            null,

            // INCIDENTS
            <ButtonCmp color="secondary"
                startIcon={<Add />}
                onClick={handleNewIncident}
            >NEW INCIDENT</ButtonCmp>,

            // PHOTOS
            null,

        ][dialogSa.tab] ?? null}
    </>
}


export default Actions